import { OcupationStates, OcupationTypes, TenureTypes } from '../enums';

export interface AssetTenureIndexModel {
  AssetId: number;
  WorkflowItemAssetId: number;
  TenureId: number;
  Name: string;
  NationalIdentityDocument: string;
  Percentage: number;
  TenureType: TenureTypes;
}

export interface AssetTenureEditModel {
  id: number;
  name: string;
  nationalIdentificationDocumentType: number;
  nationalIdentityDocument: string;
  percentage: number;
  tenureType: TenureTypes;
  hasCoownership: boolean;
  coowners: AssetTenureOwnerEditModel[];
}

export interface AssetTenureOwnerEditModel {
  id: number;
  name: string;
  nationalIdentificationDocumentType: number;
  nationalIdentityDocument: string;
}

// REFACTOR
// TODO: Review models when migration finished
export interface AssetTenure {
  id: number;
  name: string;
  nationalIdentificationDocumentType: number;
  nationalIdentityDocument: string;
  percentage: number;
  tenureType: TenureTypes;
  hasCoownership: boolean;
  coowners: AssetTenureOwnerEditModel[];
}

export interface AssetTenureInformationModel {
  tenures: AssetTenureEditModel[];
  ocupationState: OcupationStates;
  ocupationType: OcupationTypes;
  hasContract: boolean;
  hasNonexistenceLeasesDocument: boolean;
  lesseeNif: string;
  hasRentalRegistryNumber: boolean;
  rentalRegistryNumber: string;
}
